import axios from "axios";

export const sendVncPasswordAPI = async deviceId => {
  await axios({
    url: `/api/v2/vnc/security/send-new-password`,
    method: "POST",
    data: {
      device_id: deviceId
    }
  });
};
